import React from 'react';
import Home from '../components/Home';
import Layout from '../components/Layout';

const Index = () => {
  return (
    <Layout>
        <Home />
    </Layout>
  )
}

export default Index
